// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import { FONTWEIGHT, FONTSIZE, COLORS } from "../../utils/styles"

const container = css`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 66px;
  height: 100%;
`

const content = (selected: boolean) =>
  css`
    margin: 24px 0 16px 0;
    font-weight: ${selected ? FONTWEIGHT.MEDIUM : FONTWEIGHT.REGULAR};
    font-size: ${FONTSIZE.F18};
    color: ${selected ? COLORS.C3E51B5 : COLORS.C2C2C2C};
    cursor: pointer;
    @media (max-width: 500px) {
      margin: 12px 0 12px 12%;
    }
    text-decoration: none;
    border: 0 solid ${selected ? COLORS.C3E51B5 : "transparent"};
    border-left-width: 4px;
    padding: 4px 0;
    padding-left: 16px;
  `

export { container, content }
